import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import { StoreAuthLogout } from '@/store/modules/auth/types'
import store from '@/store'
import { registerGlobalErrorHandler as registerGlobalGyymErrorHandler } from '@/externals/gyym'
import { setPublicKey as setPayjpPublicKey } from '@/externals/payjp'
import { StoreAuthUser } from '@/store/modules/auth/types'
import '@/assets/styles/app.css'
import { getAuthUser } from '@/core/Auth'
import { asset, getImageUrl, numberFormat } from '@/utils/helper'
import {
  setPageTitle,
  setPageMeta,
  getPageTitle,
  getPageMeta,
} from '@/tools/page'

// VueThinModal
import VueThinModal from 'vue-thin-modal'
// @ts-ignore
Vue.use(VueThinModal, { autoMountPortal: false })

import breadcrumbsPlugin from '@//tools/breadcrumbsPlugin'
Vue.use(breadcrumbsPlugin)

import breakpointsPlugin from '@//tools/breakpointsPlugin'
Vue.use(breakpointsPlugin)

// vee-validate-laravel
import VeeValidateLaravel from 'vee-validate-laravel'
// @ts-ignore
Vue.use(VeeValidateLaravel)

// Icon
import Icon from '@/components/globals/Icon.vue'
Vue.component('Icon', Icon)

// payjp
setPayjpPublicKey(process.env.VUE_APP_PAY_JP_PUBLIC_KEY)

// sentry
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
Sentry.init({
  enabled: process.env.VUE_APP_STAGE !== 'local',
  dsn: process.env.VUE_APP_SENTRY_DNS,
  environment: process.env.VUE_APP_STAGE,
  integrations: [new VueIntegration({ Vue, attachProps: true }) as any],
})
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    Sentry.captureException(e.reason)
  })
}

// asset(S3やストレージに格納されているasset静的画像取得)
Vue.prototype.$asset = asset
// getImageUrl(DBに格納される画像url取得)
Vue.prototype.$getImageUrl = getImageUrl
// 数字をカンマ区切りの文字列にする
Vue.prototype.$numberFormat = numberFormat

// ページのタイトルとmetaタグの設定
Vue.prototype.$setPageTitle = setPageTitle
Vue.prototype.$setPageMeta = setPageMeta
Vue.prototype.$getPageTitle = getPageTitle
Vue.prototype.$getPageMeta = getPageMeta

Vue.config.productionTip = false

registerGlobalGyymErrorHandler((error) => {
  if (
    (error.status === 401 || error.status == 419) &&
    store.getters['auth/isLogin']
  ) {
    store.commit(new StoreAuthLogout())
    return router.push('/login')
  } else {
    return Promise.reject(error)
  }
})

const createApp = async () => {
  try {
    const authUser = await getAuthUser()
    store.commit(new StoreAuthUser(authUser))
    if (store.getters['auth/isLogin']) {
      const user = store.getters['auth/user']
      Sentry.setUser({
        id: user.id,
      })
    }
  } catch (error) {
    Sentry.captureException(error)
  }

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}

createApp()

// PWAとして認識させるようServiceWorkerを登録する
window.addEventListener('load', function () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
  }
})

if (process.env.VUE_APP_STAGE !== 'production') {
  const { GyymDebugger } = require('@/tools/gyym-debugger')
  GyymDebugger.install({ router, store })
}
